analytics = require 'utils/analytics'

module.exports =

  setDimensions: ({classroom, unit}) ->
    analytics.setCustomDimension 'classroom', classroom
    analytics.setCustomDimension 'unit', unit
